import zod from 'zod';

export const FacialControllerAvailableEvents = zod.enum(['ACCESS_CTL']);
export const FacialControllerConfigEditionFormSchema = zod.object({
  telegramIds: zod.array(zod.string()).optional(),
  whatsAppNumbers: zod.array(zod.string()).optional(),
  emailAddresses: zod.array(zod.string().max(254).email()).optional(),
  smtpIntegrationId: zod.number().optional().nullable(),
  isNotifyLogEvent: zod.boolean(),
  hasDoorConfirmation: zod.boolean(),
});
